import axios from 'axios';
import sanctumDefaultConfig from './sanctumDefaultConfig';
import { handleLogout } from '@store/actions/auth';
import { store } from '@store/storeConfig/store';

export default class sanctumService {
	// ** sanctumConfig <= Will be used by this service
	sanctumDefaultConfig = { ...sanctumDefaultConfig };

	//dejamos estas variables por si implementamos refresh token
	// ** For Refreshing Token
	isAlreadyFetchingAccessToken = false;

	// ** For Refreshing Token
	subscribers = [];
	currentExecutingRequests = {};
	constructor(sanctumOverrideConfig) {
		this.sanctumConfig = {
			...this.sanctumDefaultConfig,
			...sanctumOverrideConfig
		};

		axios.interceptors.request.use(
			(req) => {
				//tenemos que agregar a req el header de Application/json
				req.headers.Accept = 'Application/json';
				if (req.isFormData) {
					req.headers['Content-Type'] = 'multipart/form-data';
				}
				const originalRequest = req;
				if (this.currentExecutingRequests[originalRequest.requestId]) {
					const source = this.currentExecutingRequests[originalRequest.requestId];
					delete this.currentExecutingRequests[originalRequest.requestId];
					source.cancel();
				}

				const { CancelToken } = axios;
				const source = CancelToken.source();
				originalRequest.cancelToken = source.token;
				if (originalRequest.requestId) {
					this.currentExecutingRequests[originalRequest.requestId] = source;
				}
				return originalRequest;
			},
			(err) => Promise.reject(err)
		);


		// ** Request Interceptor
		/* descomentar en caso que se implemente uso de tokens de sanctum para la aplicación
        axios.interceptors.request.use(
            config => {
                // ** Get token from localStorage
                const accessToken = this.getToken()

                // ** If token is present add it to request's Authorization Header
                if (accessToken) {
                    // ** eslint-disable-next-line no-param-reassign
                    config.headers.Authorization = `${this.sanctumConfig.tokenType} ${accessToken}`
                }
                return config
            },
            error => Promise.reject(error)
        )
        */
		// ** Add request/response interceptor
		axios.interceptors.response.use(
			(response) => response,
			(error) => {
				// ** const { config, response: { status } } = error
				const { config, response } = error;
				const originalRequest = config;

				// ** if (status === 401) {
				if (response && response.status === 401) {
					store.dispatch(handleLogout());
					window.location.href = '/login';
				}
				return Promise.reject(error);
			}
		);
	}

	onAccessTokenFetched(accessToken) {
		this.subscribers = this.subscribers.filter((callback) =>
			callback(accessToken)
		);
	}

	addSubscriber(callback) {
		this.subscribers.push(callback);
	}

	getToken() {
		return localStorage.getItem(this.sanctumConfig.storageTokenKeyName);
	}

	setToken(value) {
		localStorage.setItem(this.sanctumConfig.storageTokenKeyName, value);
	}

	csrfCookie() {
		return axios.get(this.sanctumConfig.csrfCookieEndpoint);
	}

	login(...args) {
		return axios.post(this.sanctumConfig.loginEndpoint, ...args);
	}

	forgotPassword(...args) {
		return axios.post(this.sanctumConfig.forgotPasswordEndpoint, ...args);
	}

	createPassword(...args) {
		return axios.post(this.sanctumConfig.createPasswordEndpoint, ...args);
	}

	register(...args) {
		return axios.post(this.sanctumConfig.registerEndpoint, ...args);
	}

	logout(...args) {
		return axios.post(this.sanctumConfig.logoutEndpoint, ...args);
	}
}
